export const ORGANIZATION_RESET = 'ORGANIZATION_RESET'
export const ORGANIZATION_SET_ERROR = 'ORGANIZATION_SET_ERROR'
export const ORGANIZATION_SET_ITEMS = 'ORGANIZATION_SET_ITEMS'
export const ORGANIZATION_TOGGLE_LOADING = 'ORGANIZATION_TOGGLE_LOADING'
